import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateDeclaracionJuradaGarantiasLaboralesByID = () => {
  const [loadingUpdateDeclaracionJuradaGarantiasLaboralesById, setLoadingCreateDeclaracionJuradaGarantiasLaborales] = useState(false);
  const [successUpdateDeclaracionJuradaGarantiasLaboralesById, setSuccessCreateDeclaracionJuradaGarantiasLaborales] = useState(false);
  const [errorUpdateDeclaracionJuradaGarantiasLaboralesById, setErrorCreateDeclaracionJuradaGarantiasLaborales] = useState(null);
  const [dataUpdateDeclaracionJuradaGarantiasLaboralesById, setDataDeclaracionJuradaGarantiasLaborales] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateDeclaracionJuradaGarantiasLaboralesById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateDeclaracionJuradaGarantiasLaborales(true);
    setSuccessCreateDeclaracionJuradaGarantiasLaborales(false);
    setErrorCreateDeclaracionJuradaGarantiasLaborales(null);

    apiRecord.updateSolicitudDeclaracionJuradaGarantiasByID(userId, formId, data).then((res: any) => {
      setLoadingCreateDeclaracionJuradaGarantiasLaborales(false);
      setSuccessCreateDeclaracionJuradaGarantiasLaborales(true);
      setDataDeclaracionJuradaGarantiasLaborales(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateDeclaracionJuradaGarantiasLaborales(false);
      setErrorCreateDeclaracionJuradaGarantiasLaborales(err.response.data)
    })
  }

  return {
    updateDeclaracionJuradaGarantiasLaboralesById,
    loadingUpdateDeclaracionJuradaGarantiasLaboralesById,
    successUpdateDeclaracionJuradaGarantiasLaboralesById,
    errorUpdateDeclaracionJuradaGarantiasLaboralesById,
    dataUpdateDeclaracionJuradaGarantiasLaboralesById
  }

}

export default useUpdateDeclaracionJuradaGarantiasLaboralesByID;
